import React, { useState } from 'react';

/**
 * Password input with visibility toggle (eye icon).
 * Drop-in replacement for <input type="password" ... />
 * Pass any props you'd normally pass to an <input>.
 */
export default function PasswordInput({ className, style, ...rest }) {
  const [visible, setVisible] = useState(false);

  const wrapperStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    ...style,
  };

  const btnStyle = {
    position: 'absolute',
    right: '8px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    color: '#6b7280',
  };

  return (
    <div style={wrapperStyle}>
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '36px', width: '100%' }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        style={btnStyle}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? (
          // Eye-off icon
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
            <line x1="1" y1="1" x2="23" y2="23" />
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
          </svg>
        ) : (
          // Eye icon
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
